export const SFCONNECT = {
  PROD_URL: 'https://connect.payscale.com/services/auth/sso/akima',
  UAT_URL: 'https://payscale--uat.sandbox.my.site.com/connectpayscale/services/auth/sso/akima'
};